<ui-table [rows]="orders()" [responsive]="false" [collapsible]="false" [collapsibleRow]="true" [collapsibleIcon]="false">
  <div name="created-at" uiTableColumn>
    <ng-template uiTableHeader>
      {{ helperService.ColumnLabels.ORDER_DATE }}
      <small class="th-subline">{{ helperService.ColumnLabels.ORDER_TIME }}</small>
    </ng-template>
    <ng-template let-order="item" uiTableCell>
      {{ order.orderedAt | luxonDate }}
      <small>{{ order.orderedAt | luxonDate: "T" }} Uhr</small>
    </ng-template>
  </div>
  <div name="order-number" uiTableColumn>
    <ng-template uiTableHeader>
      {{ helperService.ColumnLabels.ID_INVOICE_NR }}
      <small class="th-subline">{{ helperService.ColumnLabels.CUSTOMER_ORDER_NR }}</small>
    </ng-template>
    <ng-template let-order="item" uiTableCell>
      <a [link]="orderLink(order)" [matTooltip]="helperService.ColumnLabels.SHOW_ORDER_RECORD" matTooltipPosition="above" uiLink>{{ invoiceNumber(order) }}</a>
      <small>{{ orderNumber(order) }}</small>
    </ng-template>
  </div>
  <!--
  @todo This part will be used in future implementations!
  <div name="order-type" uiTableColumn>
   <ng-template uiTableHeader>
     {{ helperService.ColumnLabels.CONTRACT_TYPE }}
   </ng-template>
   <ng-template let-order="item" uiTableCell>

     @todo Add this if the order lead time is available
     <span>(48h Bestellvorlauf)</span>

     {{ order.purchaseType }}
   </ng-template>
 </div>
 -->
  <div name="totals" uiTableColumn *uiPriceVisibility>
    <ng-template uiTableHeader>
      <span class="has-sum">
        {{ helperService.ColumnLabels.NET }}
        <small class="th-subline">{{ helperService.ColumnLabels.GROSS }}</small>
      </span>
    </ng-template>
    <ng-template let-order="item" uiTableCell>
      <div class="has-sum">
        <span>{{ order.totals.net | number: '1.2-2' }} €</span>
        <small>{{ order.totals.gross | number: '1.2-2' }} €</small>
      </div>
    </ng-template>
  </div>
  <div name="order-items-length" uiTableColumn>
    <ng-template uiTableHeader>
      {{ helperService.ColumnLabels.POSITIONS }}
    </ng-template>
    <ng-template let-order="item" uiTableCell>
      <div class="has-positions">
        <span class="pos-count">{{ order.items.length }}</span>
        <span class="pos-labels">
          @if (order.positionsNotAvailable > 0) {
            <span class="not-available text-smaller">
              <ui-icon faStyle="light" faName="circle-info"></ui-icon>
              {{ order.positionsNotAvailable }} {{ helperService.ColumnLabels.POSITIONS_NOT_AVAILABLE }}
            </span>
          }
        </span>
      </div>
    </ng-template>
  </div>
  <div name="delivery-status" uiTableColumn>
    <ng-template uiTableHeader>
      {{ helperService.ColumnLabels.DELIVERY_INFO }}
    </ng-template>
    <ng-template let-order="item" uiTableCell>
      @if (order.deliveryFrom && order.deliveryTo && order.deliveryFrom !== order.deliveryTo) {
        {{ order.deliveryFrom | luxonDate }} | {{ order.deliveryTo | luxonDate }}
      } @else if (order.deliveryFrom) {
        {{ order.deliveryFrom | luxonDate }}
      } @else if (order.deliveryTo) {
        {{ order.deliveryTo | luxonDate }}
      } @else {
        {{ helperService.ColumnLabels.NOT_SPECIFIED }}
      }
    </ng-template>
  </div>
  <div name="order-status" uiTableColumn>
    <ng-template uiTableHeader>
      {{ helperService.ColumnLabels.ORDER_STATUS }}
    </ng-template>
    <ng-template let-order="item" uiTableCell>
      <ui-order-history-status [orderStatus]="order.status"></ui-order-history-status>
    </ng-template>
  </div>
  <div name="actions" uiTableColumn>
    <ng-template uiTableHeader>
      <div class="has-actions-th">
        {{ helperService.ColumnLabels.ACTIONS }}
      </div>
    </ng-template>
    <ng-template let-order="item" uiTableCell>
      <ui-order-history-actions
        [order]="order"
        (openSrmForm)="onOpenSrmForm(order.id)"
        (openDocuments)="onOpenDocuments(order.id)"
        class="has-actions"
      ></ui-order-history-actions>
    </ng-template>
  </div>

  <!-- Collapsible Row: SRM Form / Receipt Documents -->
  <ng-template let-order="item" uiTableRowCollapsible>
    @if (panelExpanded()?.orderId === order.id) {
      @if (panelExpanded()?.panel === 'srm') {
        <div class="srm-form">
          <div class="panel-header">
            <h3>Ihr Anliegen</h3>
            <ui-icon-button
              icon="xmark-large"
              buttonStyle="unthemed"
              iconStyle="light"
              (clicked)="onPanelClosed()"
            ></ui-icon-button>
          </div>
          <ui-srm-create-form
            [order]="order"
            (formClosed)="onPanelClosed()"
            location="orders"
          ></ui-srm-create-form>
        </div>
      } @else if (panelExpanded()?.panel === 'documents') {
        <ui-order-history-documents [order]="order" (closed)="onPanelClosed()"></ui-order-history-documents>
      }
    }
  </ng-template>
</ui-table>
